const ENDPOINTS = {
  // authentication
  WEB_LOGIN: "/api/agronomist/login",
  FORGOT_PASSWORD: "/api/agronomist/forgotPassword",
  VERIFY_OTP: "/api/agronomist/verify",
  RESEND_OTP: "/api/agronomist/resend/otp",
  RESET_PASSWORD: "/api/agronomist/resetPassword",
  CHANGE_PASSWORD: "/api/agronomist/changePassword",
  GET_PROFILE: "/api/agronomist/profile",
  EDIT_PROFILE: "/api/agronomist/updateProfile",

  // GROWER
  ADD_GROWER: "/api/agronomist/grower/add",
  LIST_GROWER: "/api/agronomist/grower/list",
  GROWER_DETAIL: "/api/agronomist/growerDetail",
  EDIT_GROWER: "/api/agronomist/growerEdit",
  DELETE_GROWER: "/api/agronomist/growerDelete",

  // CROP
  CROP_LIST: "/api/common/crops/list",

  // FIELD
  ADD_FIELD: "/api/agronomist/grower/field/add",
  LIST_FIELD: "/api/agronomist/grower/field/list",
  DETAIL_FIELD: "/api/agronomist/grower/field/fieldDetail",
  EDIT_FIELD: "/api/agronomist/grower/field/edit",
  DELETE_FIELD: "/api/agronomist/grower/field/fieldDelete",
  GROWER_LIST_FIELD: "/api/common/growers",
  ACTIVE_FIELD_LIST: "/api/agronomist/grower/field/activeFieldList",

  //  SCOUTING

  ADD_SCOUTING: "/api/agronomist/grower/fields/addScouting",
  SCOUTING_LIST: "/api/agronomist/grower/fields/scoutingList",
  SCOUTING_DETAIL: "/api/agronomist/grower/fields/scouting/detial",
  SCOUTING_DELETE: "/api/agronomist/grower/fields/scoutingDelete",
  SCOUTING_EDIT: "/api/agronomist/grower/fields/editScouting",

  // PRODUCT
  ADD_PRODUCT: "/api/agronomist/products/list",

  // CROP PLAN
  ADD_CROP_PLAN: "/api/agronomist/cropPlan/add",
  CROP_PLAN_LIST: "/api/agronomist/cropPlan/list",
  EDIT_CROP_PLAN: "api/agronomist/cropPlan/edit",
  CROP_PLAN_DETAIL: "/api/agronomist/cropPlan/season/details",
  CROP_PLAN_DELETE: "/api/agronomist/cropPlan/cropPlanDelete",

  // SECTION
  ADD_SEASON_PLAN: "/api/agronomist/cropPlan/season/createSeason",
  EDIT_SEASON_PLAN: "/api/agronomist/cropPlan/season/editSeason",
  SEASON_PLAN_LIST: "/api/agronomist/cropPlan/season/list",
  DELETE_SEASON_PLAN: "/api/agronomist/cropPlan/season/delete",

  // CONTENT

  GET_CONTENT: "/api/common/content",
  SEASON_YEAR_LIST: "/api/agronomist/seasons/dropDown/list",
  ADD_CROP: "/api/agronomonist/edit/field",

  // DASHBOARD
  DASHBOARD: "/api/agronomist/dashboard",
};

export default ENDPOINTS;
